import React from 'react';
import { TopBar } from './TopBar';
import { PageHeader } from './PageHeader';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  pageSubtitle?: string;
  className?: string;
  showPageHeader?: boolean;
  showFooter?: boolean;
  backgroundStyle?: React.CSSProperties;
  backgroundClassName?: string;
}

export const Layout: React.FC<LayoutProps> = ({ 
  children, 
  pageTitle,
  pageSubtitle,
  className = '', 
  showPageHeader = true,
  showFooter = true,
  backgroundStyle,
  backgroundClassName = 'bg-gray-50'
}) => {
  return (
    <div className={`h-screen flex flex-col ${className}`}>
      {/* TopBar - Sempre visibile */}
      <TopBar />
      
      {/* Page Header - Sempre visibile */}
      {showPageHeader && (
        <PageHeader title={pageTitle} subtitle={pageSubtitle} />
      )}
      
      {/* Contenuto principale - Scrollabile con sfondo personalizzato */}
      <main 
        className={`flex-1 overflow-y-auto pb-24 md:pb-0 ${backgroundClassName}`}
        style={backgroundStyle}
      >
        {showPageHeader ? (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {children}
          </div>
        ) : (
          children
        )}
      </main>
      
      {/* Footer - Sempre visibile ancorato a fine pagina */}
      {showFooter && <Footer />}
    </div>
  );
};
